import { __awaiter, __extends, __generator } from "tslib";
import { SdkMessageTypes } from '../constants';
import { LogLevel, } from '../interfaces';
import { isUserSettingsChange } from '../utils/helpers';
import { BaseMessageHandler, noPermissionsError } from './base-message-handler';
import { logMessageResult } from './messageHandlingUtils';
var RegisterHandlerMessageHandler = /** @class */ (function (_super) {
    __extends(RegisterHandlerMessageHandler, _super);
    function RegisterHandlerMessageHandler(appSdkHost, pageService, logService, meetingService, meetingRoomService, remoteCameraService, searchService, telemetryService, bootstrapRegistrationState) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.bootstrapRegistrationState = bootstrapRegistrationState;
        _this.registeredHandlers = new Map();
        _this.userSettings = [];
        _this.registerHandlerImpl('themeChange', function (onEvent) { return (appSdkHost.onThemeChanged = function (newTheme) { return onEvent({ data: [newTheme] }); }); }, 'eventDispatch.themeChange');
        _this.registerHandlerImpl('userSettingsChange', function (onEvent) {
            return (appSdkHost.onUserSettingsChanged = function (userSetting, value) {
                return _this.userSettings.includes(userSetting) && onEvent({ data: [userSetting, value] });
            });
        }, 'eventDispatch.userSettingsChange');
        if (logService) {
            logService.clearListeners();
            _this.registerHandlerImpl('log.request', function (onEvent) { return logService.addEventListener('log.request', onEvent); }, 'eventDispatch.log.request', { isRestrictedToFullTrustApps: true });
        }
        if (meetingService) {
            meetingService.clearListeners();
            _this.registerHandlerImpl('meeting.liveStreamChanged', function (onEvent) { return meetingService.addEventListener('liveStreamChanged', onEvent); }, 'eventDispatch.meeting.liveStreamChanged');
            _this.registerHandlerImpl('meeting.raiseHandStateChanged', function (onEvent) { return meetingService.addEventListener('raiseHandStateChanged', onEvent); }, 'eventDispatch.meeting.raiseHandStateChanged');
            _this.registerHandlerImpl('meeting.speakingStateChanged', function (onEvent) { return meetingService.addEventListener('speakingStateChanged', onEvent); }, 'eventDispatch.meeting.speakingStateChanged');
            _this.registerHandlerImpl('meeting.meetingReactionReceived', function (onEvent) { return meetingService.addEventListener('meetingReactionReceived', onEvent); }, 'eventDispatch.meeting.meetingReactionReceived');
            _this.registerHandlerImpl('meeting.micStateChanged', function (onEvent) { return meetingService.addEventListener('micStateChanged', onEvent); }, 'eventDispatch.meeting.micStateChanged');
        }
        if (meetingRoomService) {
            meetingRoomService.clearListeners();
            _this.registerHandlerImpl('meetingRoom.meetingRoomCapabilitiesUpdate', function (onEvent) { return meetingRoomService.addEventListener('meetingRoomCapabilitiesUpdate', onEvent); }, 'eventDispatch.meetingRoomCapabilitiesUpdate');
            _this.registerHandlerImpl('meetingRoom.meetingRoomStatesUpdate', function (onEvent) { return meetingRoomService.addEventListener('meetingRoomStatesUpdate', onEvent); }, 'eventDispatch.meetingRoomStatesUpdate');
        }
        if (searchService) {
            searchService.clearListeners();
            _this.registerHandlerImpl('search.queryChange', function (onEvent) { return searchService.addEventListener('queryChange', onEvent); }, 'eventDispatch.search.queryChange');
            _this.registerHandlerImpl('search.queryClose', function (onEvent) { return searchService.addEventListener('queryClose', onEvent); }, 'eventDispatch.search.queryClose');
            _this.registerHandlerImpl('search.queryExecute', function (onEvent) { return searchService.addEventListener('queryExecute', onEvent); }, 'eventDispatch.search.queryExecute');
        }
        if (pageService) {
            pageService.clearListeners();
            _this.registerHandlerImpl('fullScreenChange', function (onEvent) { return pageService.addEventListener('fullScreenChange', onEvent); }, 'eventDispatch.fullScreenChange');
            _this.registerHandlerImpl('focusEnter', function (onEvent) { return pageService.addEventListener('focusEnter', onEvent); }, 'eventDispatch.focusEnter');
            if (pageService.appButtonService) {
                var appButtonService_1 = pageService.appButtonService;
                appButtonService_1.clearListeners();
                _this.registerHandlerImpl('appButtonClick', function (onEvent) { return appButtonService_1.addEventListener('click', onEvent); }, 'eventDispatch.appButtonClick');
                _this.registerHandlerImpl('appButtonHoverEnter', function (onEvent) { return appButtonService_1.addEventListener('hoverEnter', onEvent); }, 'eventDispatch.appButtonHoverEnter');
                _this.registerHandlerImpl('appButtonHoverLeave', function (onEvent) { return appButtonService_1.addEventListener('hoverLeave', onEvent); }, 'eventDispatch.appButtonHoverLeave');
            }
            if (pageService.configService) {
                var configService_1 = pageService.configService;
                configService_1.clearListeners();
                _this.registerHandlerImpl('changeSettings', function (onEvent) { return configService_1.addEventListener('changeSettings', onEvent); }, 'eventDispatch.changeSettings');
                configService_1.addEventListener('settings.save', function (event) {
                    _this.logEventDispatchScenario('eventDispatch.settings.save');
                    _this.appSdkHost.sendRequestMessage('settings.save', event.data ? [event.data] : []);
                });
                configService_1.addEventListener('settings.remove', function (event) {
                    _this.logEventDispatchScenario('eventDispatch.settings.remove');
                    _this.appSdkHost.sendRequestMessage('settings.remove', event.data ? [event.data] : []);
                });
            }
            if (pageService.backStackService) {
                var backStackService_1 = pageService.backStackService;
                backStackService_1.clearListeners();
                _this.registerHandlerImpl('backButton', function (onEvent) { return backStackService_1.addEventListener('backButton', onEvent); }, 'eventDispatch.backButtonPress', { eventRaiseType: 'backButtonPress' });
            }
        }
        if (remoteCameraService) {
            remoteCameraService.clearListeners();
            _this.registerHandlerImpl('remoteCamera.capableParticipantsChange', function (onEvent) { return remoteCameraService.addEventListener('capableParticipantsChange', onEvent); }, 'eventDispatch.remoteCamera.capableParticipantsChange');
            _this.registerHandlerImpl('remoteCamera.handlerError', function (onEvent) { return remoteCameraService.addEventListener('handlerError', onEvent); }, 'eventDispatch.remoteCamera.handlerError');
            _this.registerHandlerImpl('remoteCamera.deviceStateChange', function (onEvent) { return remoteCameraService.addEventListener('deviceStateChange', onEvent); }, 'eventDispatch.remoteCamera.deviceStateChange');
            _this.registerHandlerImpl('remoteCamera.sessionStatusChange', function (onEvent) { return remoteCameraService.addEventListener('sessionStatusChange', onEvent); }, 'eventDispatch.remoteCamera.sessionStatusChange');
        }
        _this.registerHandlerImpl('load', function (_) { }, 'eventDispatch.load');
        _this.registerHandlerImpl('beforeUnload', function (_) { }, 'eventDispatch.beforeUnload');
        return _this;
    }
    RegisterHandlerMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.registerHandler, function (_, type, userSettings) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (userSettings) {
                    this.userSettings = userSettings;
                }
                if (this.isValidRegistrationType(type)) {
                    this.registeredHandlers.get(type)();
                    this.appSdkHost.saveCacheableRegistrationState(type, this.userSettings);
                }
                return [2 /*return*/, logMessageResult];
            });
        }); });
        this.bootstrapRegistrationState && this.runRegisteredHandlers(this.bootstrapRegistrationState);
    };
    RegisterHandlerMessageHandler.prototype.isValidRegistrationType = function (registrationType) {
        /** Can validate registrationType to avoid force casting
         * but it would be wasteful to do the validation as the Map lookup anyway provides the
         * same info.
         */
        return this.registeredHandlers.has(registrationType);
    };
    RegisterHandlerMessageHandler.prototype.runRegisteredHandlers = function (bootstrapRegistrationState) {
        var _a, _b;
        var key;
        try {
            for (key in bootstrapRegistrationState) {
                if (this.registeredHandlers.has(key)) {
                    if (isUserSettingsChange(key) && ((_a = bootstrapRegistrationState.userSettingsChange) === null || _a === void 0 ? void 0 : _a.userSettingTypes)) {
                        this.userSettings = bootstrapRegistrationState.userSettingsChange.userSettingTypes;
                    }
                    (_b = this.registeredHandlers.get(key)) === null || _b === void 0 ? void 0 : _b();
                }
            }
        }
        catch (_) {
            // also report through telemetry
            this.appSdkHost
                .getLogger()
                .log(LogLevel.Error, 'RegisterHandlerMessageHandler', 'failed to run registered handlers');
        }
    };
    RegisterHandlerMessageHandler.prototype.registerHandlerImpl = function (type, handlerFactory, telemetryScenarioName, options) {
        var _this = this;
        if (this.registeredHandlers.has(type)) {
            throw new Error('handler already registered');
        }
        this.registeredHandlers.set(type, function () {
            var _a;
            if ((options === null || options === void 0 ? void 0 : options.isRestrictedToFullTrustApps) && !((_a = _this.appSdkHost.getAppDefinition()) === null || _a === void 0 ? void 0 : _a.isFullTrust)) {
                throw new Error(noPermissionsError);
            }
            handlerFactory(function (event) {
                var _a;
                _this.logEventDispatchScenario(telemetryScenarioName);
                if (!Array.isArray(event.data))
                    event.data = [event.data];
                _this.appSdkHost.sendRequestMessage((_a = options === null || options === void 0 ? void 0 : options.eventRaiseType) !== null && _a !== void 0 ? _a : type, event.data ? event.data : []);
            });
        });
    };
    RegisterHandlerMessageHandler.prototype.logEventDispatchScenario = function (telemetryScenarioName) {
        var _a;
        var scenario = (_a = this.telemetryService) === null || _a === void 0 ? void 0 : _a.createScenario(telemetryScenarioName);
        scenario === null || scenario === void 0 ? void 0 : scenario.stop();
    };
    return RegisterHandlerMessageHandler;
}(BaseMessageHandler));
export { RegisterHandlerMessageHandler };
//# sourceMappingURL=register-handler-message-handler.js.map